<template>
  <div id="SettingForSip" style="width: 100%">
    <div class="page-header">
      <div class="page-title">国标服务配置</div>
    </div>
    <div
      style="width: 60%; margin:0 auto; background-color: #FFFFFF; position: relative; padding: 5rem 6.5rem; text-align: left;font-size: 14px; max-width: 400px">
      <el-form ref="form" :rules="rules" :model="form" label-width="140px">
        <el-form-item label="SIP服务器IP" prop="ip">
          <el-input v-model="form.ip" clearable readonly @focus="selectAllText"></el-input>
        </el-form-item>
        <el-form-item label="SIP服务器端口" prop="port">
          <el-input v-model.number="form.port" clearable readonly @focus="selectAllText"></el-input>
        </el-form-item>
        <el-form-item label="SIP域" prop="domain">
          <el-input v-model="form.domain" clearable readonly @focus="selectAllText"></el-input>
        </el-form-item>
        <el-form-item label="SIP服务器ID" prop="id">
          <el-input v-model="form.id" clearable readonly @focus="selectAllText"></el-input>
        </el-form-item>
        <el-form-item label="SIP认证密码" prop="password">
          <el-input v-model="form.password" clearable readonly @focus="selectAllText"></el-input>
        </el-form-item>


        <el-form-item>
          <div style="float: right;">
            <!-- <el-button type="primary" @click="onSubmit">保存</el-button> -->
            <!--              <el-button @click="close">取消</el-button>-->
          </div>

        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import uiHeader from '../../layout/UiHeader.vue'

export default {
  name: "SettingForSip",
  components: {
    uiHeader
  },
  data() {
    return {
      form: {
        ip: null,
        port: null,
        domain: null,
        id: null,
        password: null,
      },
      rules: {
        ip: [{ required: true, message: "请输入名称", trigger: "blur" }],
        port: [{ required: true, message: "请输入应用名", trigger: "blur" }],
        domain: [{ required: true, message: "请输入流ID", trigger: "blur" }],
        id: [{ required: true, message: "请输入国标编码", trigger: "blur" }],
        password: [{ required: true, message: "请输入国标编码", trigger: "blur" }],
      },
    }
  },
  created() {
    this.getServerInfo();
  },
  methods: {
    getServerInfo() {
      this.$axios.get('/api/server/system/configInfo').then(res => {
        if (res.data) {
          this.form.ip = res.data.data.sip.ip === '0.0.0.0' ? res.data.data.sip.showIp : res.data.data.sip.ip;
          this.form.port = res.data.data.sip.port;
          this.form.domain = res.data.data.sip.domain;
          this.form.id = res.data.data.sip.id;
          this.form.password = res.data.data.sip.password;
        }
      }).catch(error => {
        console.error('获取SIP配置信息失败:', error);
        this.$message.error('获取SIP配置信息失败');
      });
    },
    onSubmit() {
      this.$message({
        message: 'SIP配置为只读信息，无法修改',
        type: 'warning'
      });
    },
    selectAllText(event) {
      event.target.select();
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/setting/Sip.vue